module.exports = __webpack_public_path__ + "static/media/bruno.2488bded.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/vychovakzivotu/resources/sponsors/bruno.png
// module id = 408
// module chunks = 0